import React from "react";

type Step = {
  number: number;
  title: string;
};

type Props = {
  steps: Step[];
  currentStep: number;
};

export default function StepProgress({ steps, currentStep }: Props) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-3 md:gap-8">

      {steps.map((step, index) => {
        const isActive = step.number === currentStep;
        const isCompleted = step.number < currentStep;

        return (
          <div key={index} className="flex items-center gap-3">
            {/* Bulatan angka */}
            <div
              className={`w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-full border-2 font-semibold
                ${
                  isActive
                    ? "bg-white border-primary text-primary"
                    : isCompleted
                    ? "bg-white text-primary border-primary"
                    : "border-gray-400 text-white bg-gray-400"
                }
              `}
            >
              {step.number}
            </div>

            {/* Title + Check */}
            <div className="flex items-center gap-1">
              <span className={`font-medium text-[10px] md:text-base text-white`}>{step.title}</span>

              {/* Centang kalau completed */}
              {isCompleted && (
                <span className="text-white text-lg font-bold">✔</span>
              )}
            </div>

            {/* Arrow */}
            {index < steps.length - 1 && (
              <span className="text-gray-300 text-lg">›</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
